<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">病例列表</div>
				<div class="titleR"></div>
			</div>
			<div class="content">
				<div class="con">
					<div class="tabLine">
						<div class="tabLineL">
							<div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">全部</div>
							<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">治愈中</div>
							<div class="tabItem" :class="[tabIndex===2?'active':'']" @click="changeTabIndex(2)">已治愈</div>
							<div class="tabItem" :class="[tabIndex===3?'active':'']" @click="changeTabIndex(3)">已死亡</div>
							<div class="tabItem" :class="[tabIndex===4?'active':'']" @click="changeTabIndex(4)">其它</div>
						</div>
						<div class="tabLineR"></div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:250px;margin-right: 10px;" placeholder="请输入顾客名称或手机号" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">检测状态</div>
							<el-select style="width:120px" v-model="search.isInspect" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'已检测',value:1},{label:'未检测',value:0}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="searchLabel">使用类型</div>
							<el-select style="width:120px" v-model="search.useType" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'不限',value:0},{label:'顾客',value:1},{label:'百天保障',value:2},{label:'自用',value:3}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="searchLabel">支付状态</div>
							<el-select style="width:120px"  v-model="search.isPay" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'已支付',value:1},{label:'未支付',value:0}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<!-- <div class="searchLabel">回访状态</div>
							<el-select style="width:120px" v-model="search.isVisit" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'已回访',value:1},{label:'待回访',value:0}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select> -->
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="病例单号" prop="caseNumber" width="110">
								<template slot-scope="props">
									<span>{{props.row.caseNumber}}</span>
									<span v-if="props.row.oneSelf" style="color:rgb(253, 78, 78)"> (自用)</span>
									<span v-if="props.row.petRights===1" style="color:rgb(253, 78, 78)"> (百天保障)</span>
									<span v-if="props.row.petRights===2" style="color:rgb(253, 78, 78)"> (万元医疗)</span>
									<el-tooltip v-if="!$public.isNull(props.row.archivesCode)" class="item" effect="dark" :content="'档案号：'+props.row.archivesCode" placement="top-start">
										<img src="../../../../assets/img/yiliaoxin/dangan.png" style="vertical-align: middle;margin-left:3px;width:15px;height: 15px;"/>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column label="顾客" prop="memberName" min-width="80">
							</el-table-column>
							<el-table-column label="手机号" prop="memberMobile" min-width="100">
							</el-table-column>
							<el-table-column label="宠物" prop="petName" min-width="150">
								<template slot-scope="props">
									{{props.row.petName}} |
									{{props.row.typeName}} |
									{{props.row.sex}} |
									{{props.row.birthDay&&props.row.birthDay.length>4?($public.FAge(new Date(props.row.birthDay).getTime())[0]+'岁'+$public.FAge(new Date(props.row.birthDay).getTime())[1]+'月'):''}}
								</template>
							</el-table-column>
							<el-table-column label="症状" min-width="120">
								<template slot-scope="props">
									<div v-for="tag1 in props.row.diagnosisTags" :key="tag1.key">
										<span >{{tag1.value}}-</span>
										<span v-for="tag2 in tag1.symptom" :key="tag2.key">
											<span v-for="tag3 in tag2.symptomLevel" :key="tag3.key">
												<span >{{tag2.value}}-</span>
												<span >{{tag3.value}}; </span>
											</span>
										</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="康复情况" min-width="70">
								<template slot-scope="props">
									<span v-if="props.row.completeState===1">治愈中</span>
									<span v-if="props.row.completeState===2">已治愈</span>
									<span v-if="props.row.completeState===3">死亡</span>
									<span v-if="props.row.completeState===4">其它</span>
								</template>
							</el-table-column>
							<el-table-column label="医生" prop="doctorName" min-width="60">
							</el-table-column>
							<el-table-column label="挂号时间" min-width="120">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.registrationTime,'YYYY-MM-DD HH:mm')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="病例日期" min-width="90">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="检测" min-width="60">
								<template slot-scope="props">
									<div style="color:#FD4E4E">{{props.row.isInspect==0?'未检测':''}}</div>
									<div style="color:#18A44C">{{props.row.isInspect==1?'已检测':''}}</div>
								</template>
							</el-table-column> 
							<el-table-column label="状态" min-width="60">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" min-width="80">
							</el-table-column>
							<el-table-column label="操作" min-width="120">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toSee(props.row)">查看</el-button>
									<el-button v-show="$buttonAuthority('yewu-yiliaoxin-editbingli')" type="text" @click="toEdit(props.row)" size="mini">编辑</el-button>
									<el-button v-show="$buttonAuthority('yewu-yiliaoxin-delbingli')" v-if="props.row.isPay==false" type="text" @click="del(props.row)" size="mini">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tabIndex:0,
				search:{
					keyword:'',
					departmentId:'',
					isPay:-1,
					isInspect:-1,
					isVisit	:-1,
					useType:0,
				},
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			bingliParams(){
				return this.$store.state.yiliaoxin.bingliParams;
			},
		},
		created(){
			this.page.page = this.bingliParams.curPage||1
			// let tabIndex = this.$route.query.tabIndex;
			// if(!this.$public.isNull(tabIndex)){
			// 	this.tabIndex = tabIndex
			// }
		},
		mounted(){
			this.tabIndex = this.bingliParams.initialDataOflist.tabIndex||this.tabIndex;
			this.search = this.bingliParams.initialDataOflist.search||this.search;
			this.page = this.bingliParams.initialDataOflist.page||this.page;
			this.getTableData();
			
		},
		methods: {
			reset(){
				this.search = {
					keyword:'',
					departmentId:'',
					isPay:-1,
					isInspect:-1,
					isVisit	:-1,
					useType	:0,
				};
				this.page.page=1;
				this.getTableData()
			},
			toSee(row){
				this.bingliParams.curRow = row
				this.bingliParams.type = "see"
				this.$store.commit("yiliaoxin/set_bingliParams",this.bingliParams)
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:this.bingliParams})
			},
			toEdit(row){
				this.bingliParams.curRow = row
				this.bingliParams.type = "edit"
				this.$store.commit("yiliaoxin/set_bingliParams",this.bingliParams)
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:this.bingliParams})
			},
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 删除
			del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/Case/Delete', {caseNumber:row.caseNumber}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 切换列表
			changeTabIndex(index){
				this.tabIndex=index;
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let loading=this.$loading();
				let params = {
					"departmentId": this.search.departmentId,
					"petId": "", 
					isPay:this.search.isPay, // -1不限；0未支付；1已支付
					isInspect:this.search.isInspect,  // -1不限；0未检测；1已检测
					isVisit:this.search.isVisit,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					showLater:false,
					"desc": true, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": (this.search.keyword).trim(),
					completeState: this.tabIndex,  // 1治疗中；2已治愈；3死亡
					useType:this.search.useType,// 使用类型  0不限；1顾客，2百天保障，3自用
				}
				// if(this.datetimerange&&this.datetimerange.length==2){
				// 	params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
				// 	params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				// }
				console.log(params)
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.bingliParams.initialDataOflist = {
					tabIndex:this.tabIndex,
					search:this.search,
					page:JSON.parse(JSON.stringify(this.page)),
				}
				this.$store.commit("yiliaoxin/set_bingliParams",JSON.parse(JSON.stringify(this.bingliParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'病例',data:JSON.parse(JSON.stringify(this.bingliParams))})
			},
		},
		// beforeDestroy(){
		// 	this.bingliParams.initialDataOflist = {
		// 		tabIndex:this.tabIndex,
		// 		search:this.search,
		// 		page:this.page,
		// 	}
		// 	this.$store.commit("yiliaoxin/set_bingliParams",JSON.parse(JSON.stringify(this.bingliParams)))
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;
				}
			}
			.content{
				position: relative;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;height: 100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
